import { createContext } from 'react';
import { ShowToastProps } from './types';

export type NotificationsContextType = {
  showToast(params: ShowToastProps): void;
};

export const NotificationsContext = createContext<NotificationsContextType>(
  {} as NotificationsContextType
);
